import Vue from 'vue'
import Router from 'vue-router'
import DefaultLayout from './layouts/Default'
import About from './views/About'
import Account from './views/account/Account'
import store from './store'
import { updateUrlFiltersParam, updateUrlParam } from './util/url'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',  
      component: DefaultLayout,
      children: [
        {
          path: 'test',
          name: 'test',
          component: () => import('./views/Test')
        },
        {
          name: 'retail-product-details',
          path: 'productDetails/:id',
          meta: {
            title: 'Retail Store - Product Details'
          },
          component: () => import('./views/retail_store/ProductDetails')
        },                  
        {
          path: 'home',
          name: 'home',
          meta: { isHome: true },
          component: () => import('./views/Home')
        },
        {
          path: 'reset',
          name: 'reset',
          redirect: 'retail/grid'
        },
        {
          path: '',
          name: 'store',
          redirect: 'retail/grid'
        },
        {
          path: 'login',
          name: 'login',
          meta: {
            title: 'Login'
          },
          component: () => import('./views/Login')
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: () => import('./views/ResetPassword'),
        },        
        {
          name: 'forgot-password-uuid',
          path: 'forgot-password/:id',
          component: () => import('./views/ResetPassword')
        },
        {
          path: 'login-retail',
          name: 'login-retail',
          meta: {
            title: 'Login'
          },
          component: () => import('./views/LoginRetail')
        },
        {
          path: 'register',
          name: 'register',
          meta: {
            title: 'Register'
          },
          component: () => import('./views/Register')
        },
        {
          path: 'register-retail',
          name: 'register-retail',
          meta: {
            title: 'Register'
          },
          component: () => import('./views/RegisterRetail')
        },
        {
          path: 'retail',
          name: 'retail store',
          redirect: 'retail/grid',
          component: () => import('./views/retail_store/Products'),
          // meta: { requiresAuth: true },
          children: [
            {
              name: 'retail-product-details',
              path: 'productDetails',
              meta: {
                title: 'Retail Store - Product Details'
              },
              component: () => import('./views/retail_store/ProductDetails')
            },            
            {
              name: 'retail-product',
              path: 'products/:id',
              meta: {
                title: 'Retail Store - Product'
              },
              component: () => import('./views/retail_store/Products')
            },
            {
              name: 'retail-grid',
              path: 'grid',
              meta: {
                title: 'Retail Store - Grid'
              },
              component: () => import('./components/ProductGrid')
            },
            {
              name: 'retail-table',
              path: 'table',
              meta: {
                title: 'Retail Store - Table'
              },
              component: () => import('./components/ProductTable')
            }
          ]
        },
        {
          name: 'retail cart',
          path: '/retail/cart',
          component: () => import('./views/retail_store/Cart'),
          meta: {
            // requiresAuth: true,
            title: 'Retail Cart'
          }
        },
        {
          name: 'retail place order',
          path: '/retail/place-order/:id',
          component: () => import('./views/retail_store/PlaceOrder'),
          meta: {
            requiresAuth: true,
            title: 'Thanks For Retail Ordering'
          }
        },  
        {
          path: 'stock',
          name: 'hold store',
          redirect: 'stock/grid',
          component: () => import('./views/holds_store/Products'),
          meta: { requiresAuth: true },
          children: [
            {
              name: 'stock-product',
              path: 'products/:id',
              meta: {
                title: 'Stock Store - Product'
              },
              component: () => import('./views/holds_store/Products')
            },
            {
              name: 'stock-grid',
              path: 'grid',
              meta: {
                title: 'Stock Store - Grid'
              },
              component: () => import('./components/ProductGrid')
            },
            {
              name: 'stock-table',
              path: 'table',
              meta: {
                title: 'Stock Store - Table'
              },
              component: () => import('./components/ProductTable')
            }
          ]
        },
        {
          name: 'stock cart',
          path: '/stock/cart',
          component: () => import('./views/holds_store/Cart'),
          meta: {
            requiresAuth: true,
            title: 'Stock Cart'
          }
        },
        {
          name: 'stock place order',
          path: '/stock/place-order/:id',
          component: () => import('./views/holds_store/PlaceOrder'),
          meta: {
            requiresAuth: true,
            title: 'Thanks For Ordering'
          }
        },
        {
          path: 'container',
          name: 'container store',
          redirect: 'container/grid',
          component: () => import('./views/container_store/Products'),
          meta: { requiresAuth: true },
          children: [
            {
              name: 'conatiner-product',
              path: 'products/:id',
              meta: {
                title: 'Container Store - Product'
              },
              component: () => import('./views/container_store/Products')
            },
            {
              name: 'container-grid',
              path: 'grid',
              meta: {
                title: 'Container Store - Grid'
              },
              component: () => import('./components/ProductGrid')
            },
            {
              name: 'container-table',
              path: 'table',
              meta: {
                title: 'Container Store - Table'
              },
              component: () => import('./components/ProductTable')
            }
          ]
        },
        {
          name: 'container cart',
          path: '/container/cart',
          component: () => import('./views/container_store/Cart'),
          meta: {
            requiresAuth: true,
            title: 'Container Cart'
          }
        },
        {
          name: 'container place order',
          path: '/container/place-order/:id',
          component: () => import('./views/container_store/PlaceOrder'),
          meta: {
            requiresAuth: true,
            title: 'Thanks For Ordering'
          }
        },
        {
          path: '/about',
          name: 'about',
          component: About
        },
        {
          path: '/account',
          name: 'account',
          component: Account,
          meta: { requiresAuth: true },
          children: [
            {
              name: 'accountDetails',
              path: 'details',
              component: () => import('./views/account/Details')
            },
            {
              name: 'accountDetailsRetail', 
              path: 'details-retail',
              component: () => import('./views/account/DetailsRetail')
            },
            {
              name: 'accountFavouriteColours',
              path: 'favourite-colours',
              component: () => import('./views/account/FavouriteColours')
            },
            {
              name: 'accountOrders',
              path: 'orders',
              component: () => import('./views/account/AccountOrders')
            },
            {
              name: 'stockOrder',
              path: 'orders/stock/:id',
              component: () => import('./views/account/StockOrder')
            },
            {
              name: 'accountContainerOrder',
              path: 'orders/container/:id',
              component: () => import('./views/account/ContainerOrder')
            },
            {
              name: 'accountRetailOrder',
              path: 'orders/retail/:id',
              component: () => import('./views/account/RetailOrder')
            }
          ]
        },
        {
          path: '/admin',
          name: 'admin',
          component: () => import('./views/admin/AdminLayout'),
          meta: { requiresAuth: true, requiresAdminAuth: true },
          children: [          
            {
              name: 'genarateOrders',
              path: '/admin/go',
              component: () => import('./views/admin/GenerateOrders')
            },              
            // {
            //   name: 'helper',
            //   path: '/admin/helper',
            //   component: () => import('./views/admin/Helper3')
            // },
            {
              name: 'stockManagement',
              path: '/admin/stockManagement',
              component: () => import('./views/admin/StockManagement')
            },                          
            {
              name: 'importFromOrderForm',
              path: '/admin/importFromOrderForm',
              component: () => import('./views/admin/ImportFromOrderForm')
            },
            {
              name: 'newColour',
              path: '/admin/add-colour',
              component: () => import('./views/admin/AddColour')
            },
            {
              name: 'newColourFromLink',
              path: '/admin/add-colour-link',
              component: () => import('./views/admin/AddColour')
            },                      
            {
              name: 'coloursTable',
              path: '/admin/coloursTable',
              component: () => import('./views/admin/ColoursTable')
            },  
            {
              name: 'editColour',
              path: '/admin/edit-colour/:id',
              component: () => import('./views/admin/EditColour')
            },                      
            {
              name: 'adminAccounts',
              path: 'accounts',
              component: () => import('./views/admin/Accounts')
            },
            {
              name: 'adminAccount',
              path: 'accounts/:id',
              component: () => import('./views/admin/Account')
            },
            {
              name: 'adminStockOrders',
              path: 'stock-orders',
              component: () => import('./views/admin/StockOrders')
            },
            {
              name: 'adminStockOrder',
              path: 'stock-orders/:id',
              component: () => import('./views/admin/StockOrder')
            },
            {
              name: 'adminContainerOrders',
              path: 'container-orders',
              component: () => import('./views/admin/ContainerOrders')
            },
            {
              name: 'adminContainerOrder',
              path: 'container-orders/:id',
              component: () => import('./views/admin/ContainerOrder')
            },
            {
              name: 'adminRetailOrders',
              path: 'retail-orders',
              component: () => import('./views/admin/RetailOrders')
            },
            {
              name: 'adminRetailStoreSettings',
              path: 'retail-settings',
              component: () => import('./views/admin/RetailStoreSettings')
            },
            {
              name: 'adminRetailOrder',
              path: 'retail-orders/:id',
              component: () => import('./views/admin/RetailOrder')
            },
            {
              name: 'adminBrandOrder',
              path: 'brand-orders/:id',
              component: () => import('./views/admin/BrandOrder')
            },
            {
              name: 'adminGroupOrders',
              path: 'group-orders',
              component: () => import('./views/admin/GroupOrders')
            },
            {
              name: 'adminGroupOrder',
              path: 'group-orders/:id',
              component: () => import('./views/admin/GroupOrder')
            },
            {
              name: 'adminEmailTemplates',
              path: 'email-templates',
              component: () => import('./views/admin/EmailTemplates')
            },
            {
              name: 'adminEmailTemplate',
              path: 'email-templates/:id',
              component: () => import('./views/admin/EmailTemplate')
            },
            {
              name: 'adminProducts',
              path: 'products',
              component: () => import('./views/admin/Products')
            },
            {
              name: 'adminStockProduct',
              path: 'products/:id',
              component: () => import('./views/admin/Product')
            },
            {
              name: 'adminAddFromGroupOrder',
              path: 'add-stock-from-group-order/:id',
              component: () => import('./views/admin/AddStockFromGroupOrder')
            },            {
              name: 'adminAddStock',
              path: 'add-stock',
              component: () => import('./views/admin/AddStock')
            },
            {
              name: 'adminDownloadStockList',
              path: 'download-stock-list',
              component: () => import('./views/admin/DownloadStockList')
            },
            {
              name: 'adminImportExportProducts',
              path: 'import-export-products',
              component: () => import('./views/admin/ImportExportProducts')
            },
            {
              name: 'adminColours',
              path: 'colours',
              component: () => import('./views/admin/Colours')
            },
            {
              name: 'adminBackups',
              path: 'backups',
              component: () => import('./views/admin/Backups')
            },
            {
              name: 'adminVoucher',
              path: 'vouchers/:id',
              component: () => import('./views/admin/Voucher')
            },
            {
              name: 'adminVouchers',
              path: 'vouchers',
              component: () => import('./views/admin/Vouchers')
            },
            {
              name: 'adminXero',
              path: 'xero',
              component: () => import('./views/admin/Xero')
            }
          ]
        },
        {
          name: 'Maintenance',
          path: '/maintenance',
          component: () => import('./views/Maintenance')
        },           
        {
          name: 'Contact',
          path: '/contact',
          component: () => import('./views/Contact')
        },         
        {
          name: 'Terms And Conditions',
          path: '/terms-and-conditions',
          component: () => import('./views/TermsAndConditions')
        },
        {
          name: 'Thanks For Registering',
          path: '/thanks-for-registering',
          component: () => import('./views/ThanksForRegistering')
        },
        {
          name: 'Stripe Test',
          path: '/stripe-test',
          component: () => import('./views/StripeTest')
        },
        {
          name: '403',
          path: '/errors/403',
          component: () => import('./views/errors/403')
        },
        { // Always leave this as last one
          path: '*',
          component: () => import('./views/errors/404')
          // meta: { title: route => 'Submind: 404' }
        }
      ]
    }
  ]
})

router.afterEach(async (to, from) => {
  // eslint-disable-next-line no-undef
  analytics.page('', to.name, {
    path: to.fullPath,
    referrer: from.fullPath
  })
  if ('product' in to.query) {
    store.commit('setSelectedProductId', atob(to.query.product))
  } else {
    store.commit('setSelectedProductId', null)
  }
  if (store.state.filters.search) {
    Vue.nextTick(() => {
      updateUrlParam('search', store.state.filters.search)
    })
  } else if ('search' in to.query) {
    store.commit('filters/setSearch', atob(to.query.search))
  }
  if (store.state.filters.filters && store.state.filters.filters.length) {
    Vue.nextTick(() => {
      updateUrlFiltersParam(store.state.filters.filters)
    })
  } else if ('filters' in to.query) {
    let filters = JSON.parse(atob(to.query.filters))
    let colourFilter = filters.find(filter => filter.type === 'colour')
    if (colourFilter) {
      await store.dispatch('filters/waitUntilLoaded')
      colourFilter.values = colourFilter.values.map(colour => store.state.filters.colours.find(c => c.name === colour)).filter(c => !!c)
    }
    store.commit('filters/setFilters', filters)
  }
  // document.title = 'Climb ICP' + (to.meta.title ? ' - ' + to.meta.title : '')
  // history.replaceState('', title, `/#${to.path}`)
})

// function hasQueryParams (route) {
//   return !!Object.keys(route.query).length
// }

// router.beforeEach((to, from, next) => {
//   if (!hasQueryParams(to) && hasQueryParams(from)) {
//     next({ name: to.name, query: encodeParams(from.query) })
//   } else {
//     next()
//   }
// })

router.beforeEach(async (to, from, next) => { 
  await store.dispatch('auth/waitUntilLoaded')
  await store.dispatch('auth/init')
  const user = store.state.auth.currentAccount
  const loggedIn = !!user
  const routeRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const routeRequiresAdminAuth = to.matched.some(record => record.meta.requiresAdminAuth)
  const isHome = to.matched.some(record => record.meta.isHome)
  const uuid = store.state.auth.currentUUID

  if (to.path.includes('cart')) {
    await store.dispatch('auth/setStripeKey',store.state.auth.currentUUID)
  } 

  if (to.path.includes('productDetails')) {
    //Ugly fix for productDetails not getting the activeRetailCart.id on time for the apollo query to use it.
    async function waitForcart(){
      return new Promise((resolve,reject) =>{
          setTimeout(() => {
            store.commit('auth/setRetailCartId',store.state.cart.activeRetailCart.id)
            resolve();
          }, 
          1000);        
      })
    }
    await waitForcart();
  } 

  if (store.state.auth.noNetworkConnection || store.state.auth.accessDenied) {
    next()
  } else if (isHome) {
    location.reload();
    next('/retail')
  } else if (routeRequiresAuth && !loggedIn) {
    if (to.path.includes('retail')) {
      next('/retail')
    } else if (to.path.includes('container')){
      next('/login')
    } else if (to.path.includes('stock')){
      next('/login')
    }
  } else if (routeRequiresAuth && loggedIn) {
    if (to.path.includes('stock') && !user.roles.includes('stockStoreAccess')) {
      next('/login')
    } else if (to.path.includes('container') && !user.roles.includes('containerStoreAccess')) {
      next('/login')
    }else{
      next()
    }
  } else if (routeRequiresAdminAuth && !(loggedIn && user.isAdmin)) {
    next({ path: '/errors/403', query: { redirect: to.fullPath } })
  } else if (to.name === 'home' && loggedIn) {
    if (user.roles.includes('stockStoreAccess')) {
      next('/stock')
    } else if (user.roles.includes('retailStoreAccess')) {
      next('/retail')
    } else if (user.roles.includes('containerStoreAccess')) {
      next('/container')
    } else {
      next('/account/info')
    }
  } else if (to.name === 'login' && loggedIn) {
    if (user.roles.includes('stockStoreAccess')) {
      next('/stock')
    } else if (user.roles.includes('retailStoreAccess')) {
      next('/retail')
    } else {
      next('/account/info')
    }
  } else if (to.name === 'register' && loggedIn) {
    if (user.roles.includes('stockStoreAccess')) {
      next('/stock')
    } else if (user.roles.includes('retailStoreAccess')) {
      next('/retail')
    } else {
      next('/account/info')
    }
  } else if (to.path.includes('register-retail') && loggedIn ) {   
    next('/retail')
  } else if (to.path.includes('login-retail') && loggedIn ) {   
    next('/retail')
  } else if (to.path.includes('forgot-password') && loggedIn ) {   
    next('/retail')
  } else {    
    if (loggedIn) {
      // eslint-disable-next-line no-undef
      analytics.identify(user.id, {
        contactName: user.contactName,
        email: user.email,
        companyName: user.companyName,
        isAdmin: user.isAdmin
      })
    }else{
      // eslint-disable-next-line no-undef
      analytics.identify(uuid, {
        contactName: "Visitor",
        email: '',
        companyName: uuid,
        isAdmin: false
      })      
    }
    next()
  }
})

export default router
